// Fallback properties data (only used if API fails)
// Real data comes from: https://www.nemacolin.com/wp-json/api/v1/properties
export const PROPERTIES = [
  {
    id: 'FALLINGROCK',
    name: 'Falling Rock',
    tagline: 'Championship golf resort',
    videoUrl: 'https://d1h6dnptlo7xad.cloudfront.net/wp-content/uploads/2023/09/29163046/nemacolin_falling-rock_9x16-1.mp4',
    hasVideo: true,
    imageUrl: 'https://d1h6dnptlo7xad.cloudfront.net/wp-content/uploads/2023/09/31155500/01_FR_homepage-hero-mobile-poster-2.jpg',
    color: '#eb801e',
    backgroundOption: 'video',
    logoUrl: 'https://six-middelware-backend.s3.amazonaws.com/images/properties/fallingrock_white.svg'
  },
  {
    id: 'CHATEAU',
    name: 'The Chateau',
    tagline: 'Luxury French-inspired manor',
    videoUrl: 'https://d1h6dnptlo7xad.cloudfront.net/wp-content/uploads/2023/09/24095414/01_TC_homepage-hero-mobile_053124-1.mp4',
    hasVideo: true,
    imageUrl: 'https://d1h6dnptlo7xad.cloudfront.net/app/uploads/2020/12/01_NC-app-chateau-property-image.jpg',
    color: '#b31b38',
    backgroundOption: 'video',
    logoUrl: 'https://six-middelware-backend.s3.amazonaws.com/images/properties/chateau_white.svg'
  },
  {
    id: 'LODGE',
    name: 'The Grand Lodge',
    tagline: 'Rustic mountain retreat',
    videoUrl: 'https://d1h6dnptlo7xad.cloudfront.net/wp-content/uploads/2023/09/11132245/KP_Nemacolin_The-Grand-Lodge_Hero_Mobile_121123-1-1.mp4',
    hasVideo: true,
    imageUrl: 'https://d1h6dnptlo7xad.cloudfront.net/wp-content/uploads/2023/12/18111505/KP_Nemacolin_The-Grand-Lodge_Hero_Mobile_Poster_121123-1.jpg',
    color: '#2b6456',
    backgroundOption: 'video',
    logoUrl: 'https://six-middelware-backend.s3.amazonaws.com/images/properties/lodge-v2.svg'
  },
  {
    id: 'RESID1',
    name: 'The Estates',
    tagline: 'Private luxury residences',
    videoUrl: 'https://d1h6dnptlo7xad.cloudfront.net/wp-content/uploads/2023/09/24112655/01_TE_homepage-hero-mobile-1.mp4',
    hasVideo: true,
    imageUrl: 'https://d1h6dnptlo7xad.cloudfront.net/wp-content/uploads/2023/09/31155501/01_TE_homepage-hero-mobile-poster-image-1.jpg',
    color: '#807d5b',
    backgroundOption: 'video',
    logoUrl: 'https://six-middelware-backend.s3.amazonaws.com/images/properties/estates_white.svg'
  },
  {
    id: 'RESID2',
    name: 'The Homes',
    tagline: 'Intimate residential experience',
    videoUrl: '',
    hasVideo: false,
    imageUrl: 'https://d1h6dnptlo7xad.cloudfront.net/app/uploads/2020/12/03_NC-app-homes-property-image.jpg',
    color: '#80a4b0',
    backgroundOption: 'image',
    logoUrl: 'https://six-middelware-backend.s3.amazonaws.com/images/properties/homes_white.svg'
  }
];